module.exports = "/assets/delice-page/drop@2x.jpg?ltE4hmX";